export default __webpack_public_path__ + "static/media/our-services-home-care-care-in-your-home.fc0d9bbd.jpg";